export default __webpack_public_path__ + "static/media/eric-hansen.6752d6bf.txt";